import React from "react";
import { usePageTheme } from "../theme/usePageTheme";
import { V2_LAYOUT } from "../styles/v2Layout";

interface V2PageFrameProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  showHomeIndicator?: boolean;
}

/** 设计稿页面框架：390 居中 + 纯黑底 */
const V2PageFrame: React.FC<V2PageFrameProps> = ({
  children,
  header,
  showHomeIndicator = true,
}) => {
  const { tokens } = usePageTheme();

  return (
    <div
      style={{
        height: "100vh",
        background: tokens.background,
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: V2_LAYOUT.pageMaxWidth,
          height: "100%",
          background: tokens.background,
          color: tokens.text,
          display: "flex",
          flexDirection: "column",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {header}
        <div
          style={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {children}
        </div>
        {showHomeIndicator ? (
          <div style={{ background: tokens.background }}>
            <div
              style={{
                height: 5,
                width: 144,
                borderRadius: 3,
                background: "#fff",
                margin: "8px auto 12px",
                opacity: 0.85,
              }}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default V2PageFrame;
